import { useTranslation } from 'next-i18next';

import { useGetIncidentReport } from '@/modules/workingDay/apiHooks';
import { Button, NextImage, Typography } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import ModalOverlay from '@/shared/components/molecules/ModalOverlay';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import WarningIcon from '~/images/shared/warning.svg';

const IncidentReportModal: React.FC<{
  closeModal: () => void;
  open: boolean;
  incidentReportId: number | null;
}> = ({ open, closeModal, incidentReportId }) => {
  const [selectedAsset] = useStore((store) => store?.asset);

  const { t } = useTranslation('common');
  const { data } = useGetIncidentReport({
    entityId: selectedAsset?.id,
    incidentReportId: incidentReportId,
  });
  const LabeledData = ({
    label,
    description,
  }: {
    label: string;
    description: string;
  }) => (
    <div className='flex-1'>
      <Typography variant='body2' className='text-text-600'>
        {label}
      </Typography>
      <Typography variant='subtitle2' className='text-black'>
        {description}
      </Typography>
    </div>
  );
  return (
    <ModalOverlay modalPosition='center' open={open} closeModal={closeModal}>
      <div className='flex h-full w-full -translate-y-20 flex-col gap-16 mobile:w-520'>
        {/* ********************* title ********************* */}
        <div className='mx-auto   text-center'>
          <div className='inline-block rounded-full bg-error-100 p-9'>
            <BaseIcon size='md'>
              <WarningIcon />
            </BaseIcon>
          </div>
          <Typography variant='body1' weight='bold'>
            {t('incident-details')}
          </Typography>
        </div>
        {/* devider */}
        <div className='border-b-sm border-background-100' />
        {/* **************** incident-details ***************** */}

        <div className='flex items-center justify-between'>
          <LabeledData label={t('name')} description={data?.name || '-'} />
          <LabeledData
            label={t('incident-reason')}
            description={data?.incidentReason || '-'}
          />
        </div>

        {/* ***************** deduction-amount ******************* */}
        <LabeledData
          label={t('deduction-amount')}
          description={
            data?.deductionAmount ? String(data?.deductionAmount) : '-'
          }
        />
        {/* *************** incident-reason-description ********** */}
        <LabeledData
          label={t('incident-reason-description')}
          description={data?.incidentReasonText || '-'}
        />

        {/* ***************** attatchment image ****************** */}

        {data?.attachment && !data?.attachment.includes('undefined') && (
          <div className='h-230 w-full rounded-lg'>
            <NextImage
              // fill
              width={200}
              height={100}
              src={data.attachment}
              alt={data.name}
              className='flex h-full w-full justify-center rounded-lg'
            />
          </div>
        )}
        {/* ***************** close button ****************** */}
        <div className='m-auto'>
          <Button size='xl' color='primary' onClick={() => closeModal()}>
            {t('close')}
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default IncidentReportModal;
